__turbopack_context__.v({
  "form": "CompatibleWithField-module-scss-module__x9uI4q__form",
  "number": "CompatibleWithField-module-scss-module__x9uI4q__number",
  "products": "CompatibleWithField-module-scss-module__x9uI4q__products",
  "wrapper": "CompatibleWithField-module-scss-module__x9uI4q__wrapper",
});
